<template>
    <div class="content p-1 mt-1" v-if="marcas?.length > 0">
        <div class="header-banner-bar" v-if="marcas?.length > 0">
            <div class="d-flex w-100 flex-column">
                <div
                    class="header-col-actualizados d-flex flex-column justify-content-center text-center p-3 bg-dark-primary">
                    <h4 class="mb-1 titulo-marcas" style="color: white!important;"><b>Nuestras Marcas</b></h4>
                </div>

                <div class="d-flex align-items-center justify-content-between p-3 bg-dark-primary">

                    <button class="btn btn-dark nav-btn" @click="prevItem" :disabled="currentIndex === 0">
                        <i class="fas fa-chevron-left"></i>
                    </button>

                    <div class="marcas-wrapper">
                        <div class="row g-3 flex-nowrap marcas-list justify-content-center"
                            :style="{ transform: 'translateX(' + -carouselTranslateX + 'px)' }">

                            <div class="marca-item" v-for="(marca, index) in marcas" :key="index"
                                @click="showMarcaInfo(index, marca.id)"
                                :class="[getMarcaColumnClass(), { 'selected': index === selectedMarca }]">

                                <div class="card marca-item__card">
                                    <img class="card-img-top marca-item__image"
                                        :src="getAbsoluteImageUrl('/img/marcas/' + marca.image)" alt="Marca Image">
                                </div>
                            </div>
                        </div>
                    </div>

                    <button class="btn btn-dark nav-btn" @click="nextItem"
                        :disabled="currentIndex >= marcas.length - visibleCount">
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
        <div v-if="selectedMarca !== null" class="lineas-container marca-details">
            <div class="linea-header marca-details__header" v-if="selectedMarca !== null">
                <h2 :class="'card-' + marcas[selectedMarca].color" class="marca-details__title">{{
                    marcas[selectedMarca].name }}</h2>

                <div class="separator marca-details__separator" :style="getSeparatorStyle()"></div>

                <p class="descripcion marca-details__description">{{ marcas[selectedMarca].descripcion }}</p>

                <div class="info-container info-box-container">
                    <div class="info-column info-box__column">
                        <i class='bx bx-list-ul info-box__icon'
                            :class="'text-brand-' + marcas[selectedMarca].color"></i>
                        <h3 class="info-box__title">Líneas</h3>
                        <p class="info-box__value" :class="'text-brand-' + marcas[selectedMarca].color">{{
                            marcaslineas.total_lineas }}</p>
                    </div>
                    <div class="info-column info-box__column">
                        <i class='bx bx-box info-box__icon' :class="'text-brand-' + marcas[selectedMarca].color"></i>
                        <h3 class="info-box__title">Productos</h3>
                        <p class="info-box__value" :class="'text-brand-' + marcas[selectedMarca].color">{{
                            marcaslineas.total_productos }}</p>
                    </div>
                    <div class="info-column info-box__column">
                        <i class='bx bx-layer info-box__icon' :class="'text-brand-' + marcas[selectedMarca].color"></i>
                        <h3 class="info-box__title">Aplicaciones</h3>
                        <p class="info-box__value" :class="'text-brand-' + marcas[selectedMarca].color">{{
                            marcaslineas.total_aplicaciones }}</p>
                    </div>
                </div>
            </div>
            <div v-if="loading" class="spinner-container">
                <div class="spinner"></div>
            </div>
            <div class="lineas-wrapper lineas-list-wrapper" v-else>
                <div v-for="(linea, lineIndex) in marcaslineas.lineas" :key="lineIndex"
                    class="linea-item linea-list__item">
                    <div class="linea-content linea-list__content">
                        <div class="row">
                            <div class="col-4 imagen-container linea-list__image-container">
                                <router-link
                                    :to="{ name: 'ListadoProductosLinea', query: { id: linea.id_linea, linea: linea.linea } }"
                                    style="text-decoration: none; color: inherit; cursor: pointer;">
                                    <img class="linea-list__image"
                                        v-if="linea.LineaPicturesUrl && linea.LineaPicturesUrl.length > 0"
                                        :src="linea.LineaPicturesUrl[0]" alt="Imagen de pruebas">
                                </router-link>
                            </div>
                            <div class="col-8 texto-container linea-list__text-container">
                                <router-link
                                    :to="{ name: 'ListadoProductosLinea', query: { id: linea.id_linea, linea: linea.linea } }"
                                    style="text-decoration: none; color: inherit; cursor: pointer;">
                                    <div class="nombre linea-list__name text-default-link">{{ linea.linea }}</div>
                                    <div class="nombre linea-list__count text-default-orange">{{ linea.productos_count
                                        }}
                                        Productos</div>
                                    <div class="nombre linea-list__count text-default-orange">{{
                                        linea.total_aplicaciones
                                        }}
                                        Aplicaciones</div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            marcas: [],
            currentIndex: 0,
            visibleCount: 4,
            itemWidth: 200, // Ancho estimado de la tarjeta + margen (ajustar en CSS)
            carouselTranslateX: 0,
            activeListIndex: null,
            isMenuActive: false,
            selectedMarca: null,
            autoplayInterval: undefined,
            marcaslineas: [],
            loading: false,
            settings: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
            breakpoints: {
                700: {
                    itemsToShow: 3,
                    snapAlign: 'center',
                },
                1024: {
                    itemsToShow: 3,
                    snapAlign: 'center',
                },
                '560px': {
                    numVisible: 1,
                    numScroll: 1
                }
            },

        };
    },
    methods: {
        getColorByNumber(number) {
            //console.log(number)
            switch (number) {
                case 'red':
                    return '#cf0a0a !important'; // Rojo
                case 'amarillo':
                    return '#ffc340 !important'; // Amarillo
                case 'blue':
                    return '#cf2a2a !important'; // Azul claro

                case 'plata':
                    return '#6b7d71 !important'; // Plata
                case 'red2':
                    return '#06283c !important'; // Otro color
                default:
                    return ''; // Por defecto, no se aplica ningún color
            }
        },
        getSeparatorStyle() {
            const color = this.marcas[this.selectedMarca].color;
            if (color === 'red') {
                return { backgroundColor: '#ffcdd2' };
            } else if (color === 'blue') {
                return { backgroundColor: '#253fce' };
            } else if (color === 'red2') {
                return { backgroundColor: '#06283c' };
            } else if (color === 'amarillo') {
                return { backgroundColor: '#ffc340' };
            } else if (color === 'plata') {
                return { backgroundColor: '#0a3143' };
            } else {
                // Color predeterminado si no coincide con ninguno de los anteriores
                return { backgroundColor: '#253fce' };
            }
        },

        showMarcaInfo(index, id) {
            if (this.selectedMarca === index) {
                // Si se hace clic en la misma marca, deselecciona y limpia la información
                this.autoplayInterval = this.marcas.length > 1 ? 2000 : undefined; // Reanudar autoplay
                this.selectedMarca = null;
                this.marcaslineas = [];
                return;
            }

            // Pausar autoplay al seleccionar una nueva marca
            this.autoplayInterval = undefined;
            this.selectedMarca = index;
            this.loading = true;

            axios.get(`/getMarcaDetails/${id}`)
                .then((response) => {
                    this.marcaslineas = response.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false; // Oculta el spinner
                });
        },
        getOverflowYStyle(lineas) {
            return lineas && lineas.length > 5 ? 'auto' : 'hidden';
        },

        handleNavTriggerClick(index) {
            this.activeListIndex = this.activeListIndex === index ? null : index;
            this.isMenuActive = this.activeListIndex !== null;
            if (this.marcas[index]) {
                this.marcas[index].showScrollList = !this.marcas[index].showScrollList;
            }
            //console.log(this.marcas)
        },

        shouldEnableScroll(lineas) {
            return lineas && lineas.length > 6;
        },
        getContainerClass(marca) {
            const colorClass = `container container--${marca.color}`;
            const overflowClass = marca.lineas.length > 5 ? 'container--with-overflow' : '';
            return `${colorClass} ${overflowClass}`;
        },

        MarcasHome() {
            axios.get('/shark').then((response) => {
                //console.log('marcas aqui estan las marcas');
                //console.log(response.data);
                //this.marcas = response.data;
                this.marcas = response.data.map((marca) => ({
                    ...marca,
                    showScrollList: false,
                }));
                this.$nextTick(() => {
                    this.calculateResponsiveParams();
                });
            }).catch(function (error) {
                console.log(error);
            });
        },
        shouldAddScroll(lineas) {
            const val = false
            if (lineas && lineas.length > 6)
                val = true
            //console.log(val)
            // Aquí puedes poner tu lógica para decidir cuándo agregar el scroll
            return true// Ajusta el número según tus necesidades
        },

        isActiveList(index) {
            return this.activeListIndex === index;
        },
        getAbsoluteImageUrl(relativeUrl) {
            // Obtén la URL base de Laravel
            const baseUrl = window.location.origin;

            // Concatena la URL base con la ruta relativa de la imagen
            return baseUrl + relativeUrl;
        },
        destroy() {
            // Limpiar arrays u objetos
            this.marcas = {};
            this.marcaslineas = [];
            this.autoplayInterval = undefined;
            // Limpiar otros recursos si es necesario
        },
        getMarcaColumnClass() {
            const width = window.innerWidth;
            const totalMarcas = this.marcas.length; // Usamos la cantidad total de marcas
            let colClass = 'col-12';

            // 1. LÓGICA RESPONSIVE BASADA EN EL VIEWPORT (Define el "máximo" de columnas)
            let maxVisible = 1; // Default
            if (width >= 1200) {
                maxVisible = 4; // Queremos 4 columnas (col-lg-3)
            } else if (width >= 992) {
                maxVisible = 3; // Queremos 3 columnas (col-lg-4)
            } else if (width >= 768) {
                maxVisible = 2; // Queremos 2 columnas (col-md-6)
            }

            // 2. CORRECCIÓN POR CONTENIDO INSUFICIENTE
            // Si la cantidad de marcas es menor o igual al máximo que queremos mostrar (maxVisible),
            // ajustamos el ancho de columna para que las marcas llenen el espacio.
            if (totalMarcas > 0 && totalMarcas <= maxVisible) {
                // Calculamos el ancho de columna necesario para llenar el 100% (12 / N)
                const newColSize = Math.floor(12 / totalMarcas);

                // Aplicamos la clase de Bootstrap más restrictiva para que la columna sea del tamaño correcto
                if (width >= 1200) {
                    colClass = `col-lg-${newColSize}`;
                } else if (width >= 992) {
                    colClass = `col-md-${newColSize}`;
                } else if (width >= 768) {
                    colClass = `col-sm-${newColSize}`;
                }

                // El carrusel se "desactiva" porque todos los elementos son visibles
                this.visibleCount = totalMarcas;
                this.currentIndex = 0; // Se asegura que empiece en cero

            } else {
                // 3. LÓGICA DE CARRUSEL (Si hay más marcas que el espacio visible)
                // Usamos la configuración por defecto para el carrusel
                if (width >= 1200) {
                    colClass = 'col-lg-3';
                    this.visibleCount = 4;
                } else if (width >= 992) {
                    colClass = 'col-lg-4';
                    this.visibleCount = 3;
                } else if (width >= 768) {
                    colClass = 'col-md-6';
                    this.visibleCount = 2;
                } else {
                    colClass = 'col-12';
                    this.visibleCount = 1;
                }
            }

            // Si la cantidad de marcas es 0 o 1, simplemente aseguramos que sea visible
            if (totalMarcas <= 1) {
                this.visibleCount = totalMarcas;
                this.currentIndex = 0;
            }

            return colClass;
        },

        // Corregido: Este método ya no calcula 'visibleCount', solo llama a la medición
        calculateResponsiveParams() {
            // Usamos la lógica de getMarcaColumnClass para establecer visibleCount.
            this.getMarcaColumnClass();

            // Medir el ancho REAL del primer elemento DESPUÉS del render.
            this.$nextTick(() => {
                const firstItem = document.querySelector('.marca-item');
                if (firstItem) {
                    // Obtenemos el ancho total del elemento, incluyendo padding y márgenes.
                    this.itemWidth = firstItem.offsetWidth;

                    // Asegurar que currentIndex no desborde al cambiar el viewport.
                    const maxIndex = Math.max(0, this.marcas.length - this.visibleCount);
                    this.currentIndex = Math.min(this.currentIndex, maxIndex);

                    this.updateTranslate();
                }
            });
        },

        updateTranslate() {
            this.carouselTranslateX = this.currentIndex * this.itemWidth;
        },

        prevItem() {
            if (this.currentIndex > 0) {
                this.currentIndex = this.currentIndex - 1;
                this.updateTranslate();
            }
        },

        nextItem() {
            if (this.currentIndex < this.marcas.length - this.visibleCount) {
                this.currentIndex = this.currentIndex + 1;
                this.updateTranslate();
            }
        },
    },
    watch: {
        isMenuActive(newValue) {
            const menuContainer = document.querySelector('.menu-container');
            if (menuContainer) {
                if (newValue) {
                    menuContainer.classList.add('active');
                } else {
                    setTimeout(() => {
                        menuContainer.classList.remove('active');
                    }, 500);
                }
            }
        },
    },
    mounted() {
        this.MarcasHome();
        window.addEventListener('resize', this.calculateResponsiveParams);
    },
    computed: {

    },
    beforeUnmount() {
        this.destroy();
        window.removeEventListener('resize', this.calculateResponsiveParams);
    },
}   
</script>
<style scoped>
.tab-buttons {
    /* Ajusta el ancho del contenedor de botones al 100% del ancho disponible */
    flex-grow: 1;

    justify-content: space-between;
    /* Distribuye los botones uniformemente 
    background-color: #bebebe;
    */

    background: rgba(6, 40, 60, 0.8);

    padding: 10px;
}

.page-header {

    padding: 20px 20px;

    color: #333;

    text-transform: uppercase;
}

.circle-container {
    background-color: transparent !important;
    justify-content: space-between;
    height: 200px;

}

/* Card de marca */
.marca-item__card {
    width: 140px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #222222;
    border: none;
    box-shadow: none;
    padding: 6px;
}

/* Imagen de marca */
.marca-item__image {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    filter: brightness(0%) invert(1);
}

@media (max-width: 991px) {
    .marca-item__card {
        width: 120px;
        height: 80px;
    }
}

@media (max-width: 576px) {
    .marca-item__card {
        width: 100px;
        height: 70px;
    }
}

.circle h2 {
    margin: 0;
}

.marca-info {
    background-color: #f0f0f0;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
    /* Centra el texto horizontalmente */
    display: flex;
    flex-direction: column;
    align-items: center;
    /* Centra el contenido verticalmente */
}

.marca-info h2 {
    margin-top: 0;
}

.marca-info p {
    margin-bottom: 10px;
}


.nav3__link {
    margin-bottom: 5px;
    break-inside: avoid;
    /* Evita que los elementos se corten entre columnas */
}

.nav3__item {
    width: 200px;
    /* Ancho deseado */
    height: 100px;
    /* Alto deseado */
    display: inline-block;
    /* Hace que los elementos li se comporten como bloques en línea */
    vertical-align: top;
    /* Alinea los elementos li en la parte superior */
    margin-bottom: 10px;
    /* Espacio entre cada elemento li */
}

.linea-image {
    width: 100px;
    /* Ajusta el ancho según tus necesidades */
    height: auto;
    /* Altura automática para mantener la proporción */
    margin-right: 20px;
    /* Espacio entre la imagen y el texto */
}

/* Estilo para el texto del nombre de la línea */
.linea-name {
    font-weight: bold;
    /* Texto en negrita */
    font-size: 16px;
    /* Tamaño de fuente */
}

/* Estilo para el texto de la descripción de la línea */
.linea-description {
    font-size: 14px;
    /* Tamaño de fuente */
    color: #666;
    /* Color del texto */
}

.lineas-container {
    display: flex;
    flex-direction: column;
    /* Asegura que los elementos se coloquen en columna */
    align-items: center;
    background-color: #fff;
    padding: 20px;
    /* Asegura que haya un poco de espacio alrededor del contenedor */
}

.info-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.info-column {
    text-align: center;
    padding: 10px;
    flex: 1;
    margin: 0 5px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    max-width: 150px;
}

.info-column:hover {
    transform: translateY(-3px);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
}

.info-column h3 {
    margin-top: 8px;
    font-size: 1rem;
    color: #333333;
}

.info-column p {
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 3px;

}

.info-column i {
    font-size: 1.5rem;
    color: #007BFF;
}


.linea-item {
    width: 33%;
    /* Cada línea ocupará el 25% del contenedor para formar 4 columnas */
    padding: 10px;
    box-sizing: border-box;
    /* Incluye el relleno en el ancho */
}


.imagen-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.imagen-container img {
    max-width: 80%;
    height: auto;
}

.texto-container {
    flex: 1;
    /* El texto ocupará todo el espacio disponible */
    display: flex;
    align-items: center;
    flex-direction: column;
    /* Nueva propiedad para apilar los elementos verticalmente */
    margin-top: 10px;
    /* Alinea verticalmente el texto con la imagen */
}

.nombre {
    font-weight: bold;
}

.descripcion {
    color: #333;
    /* Color del texto de la descripción */
}



.header {
    text-align: center;
    padding: 20px;
}

@keyframes scaleEffect {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
    }
}

.spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    /* Ajusta el alto según tus necesidades */
}

.separator {
    width: auto;
    height: 10px;
    align-items: center;
    background-color: #000;
    margin: auto;
}

.content-row {
    display: flex;
    justify-content: space-between;
}

.column {
    flex: 1;
    padding: 2%;
    margin-top: -3em;
    height: 70vh;
}

.callouts {
    background-color: transparent;
}

.bd-callout {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #ccc;
}

.imagen-negra {
    filter: saturate(0%) brightness(0%) grayscale(100%);
}

img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    height: auto;
}

.column ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow-y: hidden;
    position: relative;
    margin-top: -4.5em;

}

.column li {
    margin: 0;
    padding: 0;
    padding: 10px;

}

.column a {
    text-decoration: none;
    color: #fff;
}

.column li:hover {
    background-color: #454545;
}

button {
    background-color: #4caf50;
    color: #fff;
    padding: 10px;
    border: none;
    cursor: pointer;
}



.toggle-button {
    background: rgba(0, 0, 0, 0);
    /* Fondo transparente por defecto */
    border: none;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

.fa {
    font-size: 20px;
    transition: transform 0.3s;
}

.fa-bars {
    transform: rotate(0deg);
}

.fa-times {
    transform: rotate(90deg);
}

.card-red {

    /*box-shadow: 1px 4px 6px rgba(0, 0, 0, 0.6);
    background: linear-gradient(45deg, #ffcdd2, #cf0a0a);*/
    color: #cf0a0a;
}

.card-red2 {

    /*box-shadow: 1px 4px 6px rgba(0, 0, 0, 0.6);
    background: linear-gradient(45deg, #cf0a0a, #06283c);*/
    color: #06283c;
}

.card-amarillo {
    /*box-shadow: 1px 4px 6px rgba(0, 0, 0, 0.6);
    background-image: linear-gradient(105deg, rgba(0, 0, 0, 0.1) 40%, transparent 40%);
    background-color: #ffc340;*/

    /*box-shadow: 1px 4px 6px rgba(0, 0, 0, 0.6);
    background: linear-gradient(45deg, #06283c, #ffc340);*/
    color: #ffc340;
}

.card-blue {

    /*box-shadow: 1px 4px 6px rgba(0, 0, 0, 0.6);
    background: linear-gradient(45deg, #253fce, #163a66);*/
    color: #163a66;
}

.card-plata {

    /*
    box-shadow: 1px 4px 6px rgba(0, 0, 0, 0.6);
    background: linear-gradient(45deg, #000, #0a3143);*/
    color: #0a3143;
}


.circle-red {
    background: #cf0a0a;
}

.circle-red2 {
    background: #06283c;
}

.circle-amarillo {
    background: #ffc340;
}

.circle-blue {
    background: #163a66;
}

.circle-plata {
    background: #0a3143;
}

/* Define el estilo para el círculo seleccionado */
.card.selected {
    /* Elimina el color de borde específico y usa el mismo que el color de fondo */
    border-color: currentColor;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    /* Agrega un efecto de sombra */
}

.hide-list {
    display: none;
}

.scroll-list {
    overflow-y: scroll;
}

.column::-webkit-scrollbar {
    width: 12px;
}

.column::-webkit-scrollbar-thumb {
    background-color: black;
    /* Cambia este color según tus preferencias */
}

.column::-webkit-scrollbar-track {
    background-color: transparent;
    /* Cambia este color según tus preferencias */
}


.lineas-container {
    text-align: center;
}

.linea-header {
    margin-bottom: 20px;
    /* Espacio entre el encabezado y la sección de líneas */
    width: 100%;
    /* Asegura que el encabezado ocupe todo el ancho disponible */
    text-align: center;
    /* Centra el texto del encabezado */
}

.linea-header h2,
.linea-header .separator,
.linea-header .descripcion {
    display: block;
    margin: 0 auto;
}

.lineas-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 100%;
    /* Asegura que el contenedor de líneas ocupe todo el ancho disponible */
}

.linea-item {
    width: 33%;
    padding: 10px;
    box-sizing: border-box;
}

.ajuste {
    margin-top: 5%;
}

@media only screen and (max-width: 1366px) {
    .ajuste {
        margin-top: 7%;
    }
}

@media (max-width: 767px) {
    .tab-buttons {
        flex-direction: column;
    }

    .circle-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }



    .card-img-top {
        width: 30%;
        height: auto;
        object-fit: cover;
    }



    .linea-item {
        width: 100%;
    }

}

.spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25vh;
    /* O el tamaño que desees */
}

.spinner {
    border: 8px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    border-top: 8px solid #3498db;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

.marca-item {
    /* ... otros estilos ... */
    padding: 0 20px;
    /* Ejemplo: 15px de espacio a cada lado del item */
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>